export default __webpack_public_path__ + "static/media/email-svgrepo-com.33945199.svg";